import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, X } from "lucide-react";

const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (dismissed) return;
      const y = window.scrollY;
      const contact = document.getElementById("contact");
      const contactTop = contact ? contact.getBoundingClientRect().top + window.scrollY : Infinity;
      setVisible(y > window.innerHeight * 0.8 && y < contactTop - 400);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
    // dismissed is intentionally the only dep — onScroll, contact, contactTop are
    // local to the effect; they're recomputed each scroll tick by design.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissed]);

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.95 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-5 right-5 z-40 max-w-[330px]"
          data-testid="sticky-cta"
        >
          <div className="glass-card p-4 pr-10 shadow-[0_20px_60px_-20px_rgba(0,240,255,0.6)] relative">
            <button
              onClick={() => setDismissed(true)}
              className="absolute top-2 right-2 text-white/40 hover:text-white transition"
              aria-label="Dismiss"
              data-testid="sticky-cta-dismiss"
            >
              <X size={16} />
            </button>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              <span className="text-xs uppercase tracking-[0.18em] text-emerald-300">3 slots left this month</span>
            </div>
            <p className="text-white text-sm font-medium leading-snug mb-3">
              Get your free automation audit — no cost, no commitment.
            </p>
            <button
              onClick={scrollToContact}
              className="btn-primary w-full text-sm inline-flex items-center justify-center gap-1.5"
              data-testid="sticky-cta-btn"
            >
              Request My Audit
              <ArrowUpRight size={15} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
